import { useFeatureFlags } from '@usap/core';

export const useSparkChatEnabled = () => {
  const { f75 } = useFeatureFlags();

  const enabled = new Set(['b', '1', 1, 'on', 'true', true]);

  return enabled.has(f75 as string | number | boolean);
};
